<template>
  <el-dialog width="520px" title="编辑"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productEditVisible">
    <div class="details">

      <el-form  ref="currencyForm"  size="small" v-loading="loading"   label-position="top"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">
            <el-form-item prop="date" label="本次授权截止时间">
              <el-date-picker
                v-model="currencyForm.date"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions">
              </el-date-picker>
              <p style="color: rgba(140,139,139,1)" v-if="productDetail.order">可选范围：{{productDetail.order.start_date +' ~ ' + productDetail.order.end_date}}</p>
            </el-form-item>

            <el-form-item class="form_item_border" prop="value_code" label="">
              <div class="flex_js_wrap" style="justify-content: left">
                 <el-checkbox v-model="offline_time" :disabled="generateAuthData.is_activation == '已激活'">定期联网验证</el-checkbox>
                 <div style="margin-left: 30px"  v-if="offline_time">连续离线每 <el-input-number :disabled="generateAuthData.is_activation == '已激活'" style="width: 100px" v-model="currencyForm.value_code" :max="99" :min="1" :controls="false"></el-input-number> 天需要联网验证一次</div>
                 <div style="margin-left: 30px"  v-else>提示:未启用联网验证，激活码将无法回收，无法找回</div>
              </div>
               <p  style="color: rgba(140,139,139,1)" v-if="offline_time">只能填入正整数，最小为1，最大为99。</p>
            </el-form-item>

            <el-form-item prop="note" label="备注">
              <el-input type="textarea" v-model="currencyForm.note" placeholder="请输入备注" rows="4" maxlength="200" show-word-limit></el-input>
            </el-form-item>


      </el-form>
    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { productEdit,productDetail} from '@/api/api'
import {mapState} from "vuex";
import {convertToCurrentTimezone,convertToUTC} from '@/utils'
export default {
  name: 'product_edit_auth_date',
  props: {
    productEditVisible: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: 0,
    },
    noteText: {
      type: String,
      default: '',
    },
    generateAuthData:{
      type: Object,
      default: ()=>{},
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      offline_time:false, //定期联网验证
      currencyForm:{
        date:[],
        start_date: "",
        end_date: "",
        note:"",
        license_module_id:'',
        value_code:'',
      },
      currencyFormRules:{
        date:[{ required: true, message: '请选择本次授权截止时间', trigger: 'change'}],
        value_code:[{ required: true,trigger: 'change',validator: (rule, value, callback) => {
            if(this.offline_time && !value) return callback(new Error("请输入1-99的正整数"));
            callback()
        }}],
      },
      productDetail:{},
      pickerOptions: {
        disabledDate: (time) => {
          if (this.productDetail.order && this.productDetail.order.start_date && this.productDetail.order.end_date) {
            return (
              time.getTime() < new Date(this.productDetail.order.start_date).getTime() ||
              time.getTime() > new Date(this.productDetail.order.end_date).getTime()
            );
          }
          return false; // 如果没有设置开始或结束日期，允许选择任何日期
        },
      },
    }
  },

  created() {
    console.log(this.generateAuthData);
    if(this.generateAuthData && this.generateAuthData.license_module_id){
      this.currencyForm.license_module_id = this.generateAuthData.license_module_id
      this.currencyForm.value_code = this.generateAuthData.value_code
      if(this.generateAuthData.value_code == 0){
        this.offline_time = false
        this.currencyForm.value_code = 7
      }else{
        this.offline_time = true
      }
    }
    this.currencyForm.note = this.noteText ? this.noteText : ''
    if(this.productId){
      this.getAdminProductDetail()
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    // 获取
    getAdminProductDetail(){
      this.loading = true
      let postData = {
        id:this.productId,
      }
      productDetail(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          if(data.order.start_date){
            data.order.start_date = convertToCurrentTimezone(data.order.start_date,'/','datetime')
            data.order.end_date = convertToCurrentTimezone(data.order.end_date,'/','datetime')
          }
          this.currencyForm.date = [convertToCurrentTimezone(data.start_date,'-','datetime'), convertToCurrentTimezone(data.end_date,'-','datetime')]
          this.productDetail = data
          // console.log(new Date(this.productDetail.order.start_date).getTime());
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    handleClickConfirm(){
      this.$refs.currencyForm.validate(valid => {
        if (valid) {
          let postData = {
            id: this.productId,
            start_date: convertToUTC(this.currencyForm.date[0],'datetime'),
            end_date: convertToUTC(this.currencyForm.date[1],'datetime'),
            note:this.currencyForm.note,
            license_module_id:this.currencyForm.license_module_id,
            value_code:this.offline_time ? this.currencyForm.value_code : 0,
            module_value:this.offline_time ?  `${this.currencyForm.value_code}天` :  '无需在线校验',
          }
          this.BtnDisabled = true
          productEdit(postData).then(res => {
            if (res.code === 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.$emit('success')
                  this.$emit('update:productEditVisible', false)
                  this.BtnDisabled = false
                }
              });
            }else{
              this.BtnDisabled = false
            }
          }).catch((e) => {
            this.BtnDisabled = false
          })
        }
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productEditVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
.form_item_border{
  padding: 10px 0 5px;
  border-top:1px solid  #EBEEF5;
  border-bottom:1px solid #EBEEF5 ;
}

::v-deep .el-date-editor--datetimerange{
  width: 100%;

}

</style>
